// @flow

import React from 'react';
import { connect } from 'react-redux';
import {
  PriceTitleWrapper,
  PriceTitle,
  PriceSubTitle,
} from './priceTitle.styled';
import {
  getPricePerMonthLabel,
  getTaxNote,
} from '../../../../../../store/configuratorSettings/selectors';

type StateProps = {|
  monthPriceLabel: string,
  taxNoteLabel: string,
|};

type Props = StateProps;

const PriceTitleComponent = ({ monthPriceLabel, taxNoteLabel }: Props) => (
  <PriceTitleWrapper>
    <PriceTitle>{monthPriceLabel}</PriceTitle>
    <PriceSubTitle>{taxNoteLabel}</PriceSubTitle>
  </PriceTitleWrapper>
);

const mapStateToProps = (state): StateProps => ({
  monthPriceLabel: getPricePerMonthLabel(state),
  taxNoteLabel: getTaxNote(state),
});

export default connect<any, any, StateProps, any, any, any>(mapStateToProps)(PriceTitleComponent);
